<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultBackHref"></ion-back-button>
    </ion-buttons>
    <ion-title>PITI Calculator</ion-title>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  <form [formGroup]="form" (ngSubmit)="calculate()">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="John Doe"
          inputmode="text"
          type="text"
          formControlName="buyerName"
        >
          <div slot="label">Buyer Name:</div>
        </ion-input>
      </ion-item>
    </ion-list>

    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="$"
          inputmode="decimal"
          type="text"
          formControlName="homePrice"
          [maskito]="amountMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Home Value / Price:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="$ / %"
          inputmode="decimal"
          type="text"
          formControlName="downPayments"
          [maskito]="rateAmountMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Down Payment:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="%"
          inputmode="decimal"
          type="text"
          formControlName="interestRate"
          [min]="0"
          [max]="99"
          [maskito]="rateMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Interest Rate:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <red-searchable-select
        redErrorMessage
        [redRequired]="true"
        formControlName="mortgageTerm"
        [options]="mortgageTermData"
        placeholder="Select mortgage length"
        searchPlaceholder="Search mortgage length..."
      >
        <span searchable-select-label class="tw:whitespace-normal">
          Mortgage Length
          <ion-text color="danger">*</ion-text>
        </span>
      </red-searchable-select>
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="$ / %"
          inputmode="decimal"
          type="text"
          formControlName="annualPropertyTaxes"
          [maskito]="rateAmountMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Property Tax:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="$"
          inputmode="decimal"
          type="text"
          formControlName="annualOwnersInsurance"
          [maskito]="amountMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Annual Homeowners Insurance:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
    </ion-list>
  </form>

  <ion-button class="tw:m-4" expand="block" (click)="calculate()" [disabled]="!form.valid">
    Calculate
    <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
  </ion-button>
</red-page-content>
